/**
 * The language to open in, the first time, before anybody has chosen one.
 *
 * It reads the list the browser already keeps — the languages the reader set on their own
 * device, in their own order of preference — and returns the first one the app actually has a
 * catalogue for. Nothing is asked for and nothing is sent: the list is there for the asking.
 *
 * The country is deliberately not consulted. Finding it would mean asking for the device's
 * location or sending its address to a lookup service, and an app that promises nothing leaves
 * the device cannot do the second. A country is not a language either: Belgium reads in three,
 * Switzerland in four, and Arabic is read in more countries than it is not.
 */
export const preferredLanguage = (
  requested: readonly string[],
  offered: readonly string[],
): string | null => {
  for (const tag of requested) {
    // "nl-BE" and "nl" both want Dutch; the region says nothing the catalogue can answer to.
    const base = tag.toLowerCase().split('-')[0];
    if (base !== undefined && base.length > 0 && offered.includes(base)) return base;
  }
  return null;
};
